import { useMemo } from 'react';
import {
  ScanData,
  ScanDataEnum,
} from '../../../../scanDataApi/scanDataDefinitions';
import { JsonLabel } from '../../../components/DebugInfoSection';

/**
 * Hook that creates memoized label objects for AI Point data
 *
 * @param pointData - Array of scan data to generate labels for
 * @returns Memoized array of JsonLabel objects with id and formatted label
 */
export const useJsonLabelsPoints = (
  pointData: ScanData[] | undefined
): JsonLabel[] => {
  return useMemo(() => {
    if (!pointData || pointData.length === 0) {
      return [];
    }

    return pointData
      .map((item) => {
        const itemId = (item as { detection_id?: string }).detection_id;

        // Default with empty label
        const label: JsonLabel = {
          id: itemId || '',
          label: '',
        };

        // Only create a label if we have all the required fields
        if (
          ScanDataEnum.model_name in item &&
          ScanDataEnum.class_name in item &&
          ScanDataEnum.model_version in item
        ) {
          // Format the model name and class name with capitalized first letter
          const modelName =
            item[ScanDataEnum.model_name][0].toUpperCase() +
            item[ScanDataEnum.model_name].slice(1);

          const className =
            item[ScanDataEnum.class_name][0].toUpperCase() +
            item[ScanDataEnum.class_name].slice(1);

          // Combine parts into the label format
          label.label = `${modelName} / ${className} / ${
            item[ScanDataEnum.model_version]
          }`;
        }

        return label;
      })
      .filter((label) => label.label !== ''); // Remove any items without labels
  }, [pointData]);
};
